import { ServerDomainInfo } from '@/api/type-server'
import { Loading, Pagination, Trans } from '@/components'
import { ActionMenu } from '@/components/base/ActionMenu'
import { CollapseTableRow } from '@/components/CollapseTableRow'
import { EmptyView } from '@/components/EmptyView'
// import { showSnapshotBtnMap } from '@/hooks/useInstanceList'
import { Instance } from '@/models/instance'
import { CreateSnapshotModal } from '@/pages/instance-list/components/CreateSnapshotModal'
import { EditableInstanceName } from '@/pages/instance-list/components/EditableInstanceName'
import { InstanceDetail } from '@/pages/instance-list/components/InstanceDetail'
import { formatDomain, formatPrice } from '@/utils/formatter'

interface MemberInstancesTableProps {
  // States
  page: number
  setPage: (page: number) => void
  total: number
  instaceList: Instance[]
  loading: boolean
  domainInfos: ServerDomainInfo[]
  createSnapshotInstance: Instance | undefined
  setCreateSnapshotInstance: (instance: Instance | undefined) => void

  // Methods
  getNodeList: (page: number, force: boolean) => Promise<void>
  onRelease: (data: Instance) => Promise<void>
  onUpdate: () => void

  // Constants
  pageSize: number
  teamResID: string
}

export function MemberInstancesTable({
  page,
  total,
  instaceList,
  loading,
  domainInfos,
  createSnapshotInstance,
  setCreateSnapshotInstance,
  getNodeList,
  onRelease,
  onUpdate,
  pageSize,
  teamResID,
}: MemberInstancesTableProps) {
  return (
    <div>
      <div>
        {loading && (
          <div className="w-full flex items-center justify-center p-8">
            <Loading />
          </div>
        )}
        {!loading && instaceList.length === 0 && (
          <div className="mt-4">
            <EmptyView
              title={
                <span className="t-sm text-secondary">
                  <Trans i18nKey="common.emptyViewNoDataMsg" />
                </span>
              }
            />
          </div>
        )}
        {!loading && instaceList.length > 0 && (
          <table className="table-card mt-4 table-fixed">
            <thead>
              <tr>
                <th colSpan={1}>
                  <Trans i18nKey="instance.tableHeaderID">ID</Trans>
                </th>
                <th colSpan={2}>
                  <Trans i18nKey="instance.tableHeaderName">Name</Trans>
                </th>
                <th colSpan={1}>
                  <Trans i18nKey="instance.tableHeaderRegion">Region</Trans>
                </th>
                <th colSpan={1}>
                  <Trans i18nKey="instance.tableHeaderStatus">Status</Trans>
                </th>
                <th colSpan={1}>
                  <Trans i18nKey="instance.tableHeaderCost">Cost</Trans>
                </th>
                <th colSpan={2}>
                  <Trans i18nKey="instance.tableHeaderAction">Action</Trans>
                </th>
              </tr>
            </thead>
            <tbody>
              {instaceList.map((data) => (
                <CollapseTableRow
                  key={data.id}
                  colSpan={8}
                  tableClassName={'!border-none ring-1 ring-neutral-200 rounded-xl group'}
                  content={
                    <InstanceDetail
                      instance={data}
                      teamResID={teamResID}
                      onUpdate={onUpdate}
                      hideMonitor={false}
                      readOnly={true}
                    />
                  }
                >
                  <td className="t-sm" colSpan={1}>
                    {data.resID}
                  </td>
                  <td colSpan={2}>
                    <div className="flex items-center group">
                      <EditableInstanceName instance={data} onUpdate={onUpdate} editable={false} />
                    </div>
                  </td>
                  <td className="t-sm text-secondary" colSpan={1}>
                    {domainInfos.find((info) => info.domain === data.domain)?.displayName ||
                      formatDomain(data.domain)}
                  </td>
                  <td className="t-sm" colSpan={1}>
                    <span className={data.statusTextStyle}>{data.statusText}</span>
                  </td>
                  <td colSpan={1}>{formatPrice(data.cost, false)}</td>
                  <td colSpan={1}>
                    <ActionMenu
                      items={[
                        {
                          label: <Trans i18nKey="instance.list.action.release">Release</Trans>,
                          onClick: () => onRelease(data),
                          type: 'danger',
                          show: data.canRelease,
                        },
                        // {
                        //   label: (
                        //     <Trans i18nKey="instance.list.action.takeSnapshot">Take Snapshot</Trans>
                        //   ),
                        //   onClick: () => setCreateSnapshotInstance(data),
                        //   show:
                        //     data.canSnapshot && (showSnapshotBtnMap[data.node.image.id] ?? true),
                        // },
                      ]}
                      popupContainer="body"
                    />
                  </td>
                </CollapseTableRow>
              ))}
            </tbody>
          </table>
        )}
        {total > 0 && !loading && (
          <Pagination
            size={pageSize}
            total={total}
            current={page}
            className="justify-end mt-4"
            onChange={(page) => getNodeList(page, true)}
          />
        )}

        {createSnapshotInstance ? (
          <CreateSnapshotModal
            onClose={() => setCreateSnapshotInstance(undefined)}
            instance={createSnapshotInstance}
          />
        ) : null}
      </div>
    </div>
  )
}
